import { pluck, parseUnsafeString, datasetFactory } from '@fusioncharts/core/src/lib';
import { TrendSet, VolumeDataset } from '../dataset/candlestick';
/**
 * splice a given array with the given value
 * @param  {Array} array   on which splice opration will be executed
 * @param  {generic} value criteria to splice the array
 */
let arraySpliceByValue = (array, value) => {
    let indexOf = array.indexOf(value);
    if (indexOf !== -1) {
      array.splice(indexOf, 1);
    }
  },
  /**
   * function to remove component if name is matched with value in set
   * @param  {Object} component from where it would iterate
   * @param  {Array} set        criteria; if matched then remove
   */
  removeComponents = (component, set) => {
    let i;
    component && component.iterateComponents((child) => {
      for (i = 0; i < set.length; i++) {
        if (child.getName() === set[i]) {
          child.remove();
        }
      }
    });
  };
/**
 * function to  create dataset
 * sort data wrt. x value
 * assign dataset to its parents
 **/
export default function (chart) {
  let jsonData = chart.getFromEnv('dataSource'),
    datasetsJSON = jsonData.dataset,
    trendSet = jsonData.trendset,
    showVolumeChart = chart.getFromEnv('chartConfig').showVolumeChart, // eslint-disable-line good-practices/no-single-usage-variable
    dsType = pluck((parseUnsafeString(chart.getFromEnv('chart-attrib').plotpriceas)).toLowerCase(), 'candlestick'),
    canvas = chart.getChildren('canvas')[0], // eslint-disable-line good-practices/no-single-usage-variable
    datasetParent = canvas.getChildren('vCanvas')[0],
    volumeCanvas,
    volumeDatasetParent,
    sortedDatasetsJSON,
    set = ['candlestick', 'candlestickbar', 'candlestickline', 'trendset'];

  if (!datasetsJSON) {
    chart.setChartMessage();
    return;
  }
  sortedDatasetsJSON = datasetsJSON.slice(0);
  sortedDatasetsJSON[0] && sortedDatasetsJSON[0].data &&
    sortedDatasetsJSON[0].data.sort(function (a, b) { // eslint-disable-line good-practices/no-function-dependency
      return a.x - b.x;
    });
  datasetFactory(datasetParent, chart.getDSdef(dsType), 'dataset_' + dsType, datasetsJSON.length, sortedDatasetsJSON);
  if (dsType === 'bar') {
    arraySpliceByValue(set, 'candlestickbar');
  } else if (dsType === 'line') {
    arraySpliceByValue(set, 'candlestickline');
  } else {
    arraySpliceByValue(set, 'candlestick');
  }
  if (showVolumeChart) {
    volumeCanvas = chart.getChildren('canvas')[1];
    volumeDatasetParent = volumeCanvas.getChildren('vCanvas')[0];
    datasetFactory(volumeDatasetParent, VolumeDataset, 'dataset_volume', datasetsJSON.length, datasetsJSON);
  }

  if (trendSet) {
    datasetFactory(datasetParent, TrendSet, 'dataset_trendset', trendSet.length, trendSet);
    arraySpliceByValue(set, 'trendset');
  }
  removeComponents(datasetParent, set);
}
